import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d339a7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "offcanvas-header border-bottom py-0" }
const _hoisted_2 = { class: "left d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "offcanvas-title me-5" }, "PHARMAPIM", -1))
const _hoisted_4 = { class: "right d-flex justify-content-end align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mas fw-light" }, "refresh", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "offcanvas",
  "aria-label": "Close"
}, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "product row gx-3"
}
const _hoisted_9 = { class: "left col-2 col-xl-3" }
const _hoisted_10 = { class: "image border rounded mb-3" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "text-bg-light rounded px-3 py-2 mb-2" }
const _hoisted_13 = { class: "right col-10 col-xl-9" }
const _hoisted_14 = { class: "title mb-4" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "cnk-code text-bg-light rounded p-2 mb-3" }
const _hoisted_18 = { class: "row align-items-center" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "fs-6 item-title me-5 mb-0" }
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "fs-5 mb-0" }
const _hoisted_23 = { class: "usage row align-items-center" }
const _hoisted_24 = { class: "col item-title" }
const _hoisted_25 = { class: "col" }
const _hoisted_26 = { class: "availability row align-items-center" }
const _hoisted_27 = { class: "col item-title" }
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "mas mas-fill-1" }
const _hoisted_30 = { class: "col" }
const _hoisted_31 = { class: "fs-5 mb-0" }
const _hoisted_32 = { class: "brand row align-items-center" }
const _hoisted_33 = { class: "col item-title" }
const _hoisted_34 = { class: "col" }
const _hoisted_35 = { class: "d-flex align-items-center" }
const _hoisted_36 = { class: "fs-5 mb-0" }
const _hoisted_37 = {
  key: 0,
  class: "categories row align-items-start mb-2"
}
const _hoisted_38 = { class: "title mt-2 mb-4 d-flex justify-content-begin align-items-center" }
const _hoisted_39 = { class: "name fs-3 cu-p me-4 mb-0" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "feedback", -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = {
  key: 0,
  class: "general-feedback mb-4"
}
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col" }
const _hoisted_45 = { class: "fs-5 mb-0" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { class: "internal-category row align-items-start mb-2" }
const _hoisted_49 = { class: "col item-title" }
const _hoisted_50 = { class: "col" }
const _hoisted_51 = { class: "internal-category row align-items-start mb-2" }
const _hoisted_52 = { class: "col item-title" }
const _hoisted_53 = { class: "col" }
const _hoisted_54 = { class: "internal-category row align-items-start mb-2" }
const _hoisted_55 = { class: "col item-title" }
const _hoisted_56 = { class: "col" }
const _hoisted_57 = { class: "internal-category row align-items-start mb-2" }
const _hoisted_58 = { class: "col item-title" }
const _hoisted_59 = { class: "col" }
const _hoisted_60 = { class: "internal-category row align-items-start mb-2" }
const _hoisted_61 = { class: "col item-title" }
const _hoisted_62 = { class: "col" }
const _hoisted_63 = { class: "internal-category row align-items-start mb-2" }
const _hoisted_64 = { class: "col-5 item-title" }
const _hoisted_65 = { class: "col" }
const _hoisted_66 = { class: "pim-core-detail row align-items-start mb-2" }
const _hoisted_67 = { class: "col-5 item-title" }
const _hoisted_68 = { class: "col" }
const _hoisted_69 = { class: "pim-core-detail row align-items-start mb-2" }
const _hoisted_70 = { class: "col-5 item-title" }
const _hoisted_71 = { class: "col" }
const _hoisted_72 = { class: "pim-core-detail row align-items-start mb-2" }
const _hoisted_73 = { class: "col-5 item-title" }
const _hoisted_74 = { class: "col" }
const _hoisted_75 = { class: "pim-core-detail row align-items-start mb-2" }
const _hoisted_76 = { class: "col-5" }
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "col item-title" }
const _hoisted_79 = { class: "row" }
const _hoisted_80 = { class: "col" }
const _hoisted_81 = { class: "col" }
const _hoisted_82 = { class: "pim-core-detail row align-items-start mb-2" }
const _hoisted_83 = { class: "col" }
const _hoisted_84 = {
  class: "btn btn-sm btn-primary me-2",
  type: "submit"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1))
const _hoisted_86 = { class: "row" }
const _hoisted_87 = { class: "col" }
const _hoisted_88 = { class: "fs-5 mb-0" }
const _hoisted_89 = { class: "d-flex align-items-center justify-content-between mb-4" }
const _hoisted_90 = { class: "desciption item-title" }
const _hoisted_91 = { class: "buttons d-flex justify-content-begin align-items-center" }
const _hoisted_92 = ["onClick"]
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "feedback", -1))
const _hoisted_94 = [
  _hoisted_93
]
const _hoisted_95 = ["onClick"]
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1))
const _hoisted_97 = [
  _hoisted_96
]
const _hoisted_98 = ["onClick"]
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "delete", -1))
const _hoisted_100 = [
  _hoisted_99
]
const _hoisted_101 = ["innerHTML"]
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas ms-n1 me-1" }, "add", -1))
const _hoisted_103 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultilingualSwitcher = _resolveComponent("MultilingualSwitcher")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_Lightbox = _resolveComponent("Lightbox")!
  const _component_PimProductsOverviewItemIcons = _resolveComponent("PimProductsOverviewItemIcons")!
  const _component_PimProductsOverviewLegend = _resolveComponent("PimProductsOverviewLegend")!
  const _component_BaseCardHeader = _resolveComponent("BaseCardHeader")!
  const _component_BaseCardBody = _resolveComponent("BaseCardBody")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_PimProductsDetailCategories = _resolveComponent("PimProductsDetailCategories")!
  const _component_PimFeedbackPanelOld = _resolveComponent("PimFeedbackPanelOld")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_NamedTextFragmentPanelOld = _resolveComponent("NamedTextFragmentPanelOld")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_MultilingualSwitcher, {
          "active-language": _ctx.activeLanguage,
          languages: _ctx.languages,
          onUpdateActiveLanguage: _cache[0] || (_cache[0] = (newValue) => _ctx.activeLanguage = newValue),
          errors: {},
          mb: 0
        }, null, 8, ["active-language", "languages"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-hover",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.reloadContent && _ctx.reloadContent(...args)), ["prevent"]))
        }, _hoisted_6),
        _hoisted_7
      ])
    ]),
    _createVNode(_component_AlertError2, {
      error: _ctx.productUI.getError(),
      class: "mb-3"
    }, null, 8, ["error"]),
    _createVNode(_component_BaseSpinner, {
      spin: _ctx.productUI.isNotReady()
    }, null, 8, ["spin"]),
    (_ctx.productUI.isReady())
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_ctx.product.product_info.main_image_url)
                ? (_openBlock(), _createBlock(_component_Lightbox, {
                    key: 0,
                    sources: [_ctx.product.product_info.main_image_url],
                    class: "btn"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _ctx.product.product_info.main_image_url,
                        alt: _ctx.product.product_info.name,
                        class: "img-fluid"
                      }, null, 8, _hoisted_11)
                    ]),
                    _: 1
                  }, 8, ["sources"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_PimProductsOverviewItemIcons, { product: _ctx.product }, null, 8, ["product"])
            ]),
            _createVNode(_component_PimProductsOverviewLegend)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h2", {
                class: "name fs-3 cu-p me-4 mb-0",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.UtilityHelper.copyInnerTextToClipboard($event)), ["prevent"]))
              }, _toDisplayString(_ctx.product.product_info.name), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("h3", _hoisted_20, _toDisplayString(_ctx.$t('cnk')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("p", {
                        class: "fs-6 cu-p mb-0",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.UtilityHelper.copyInnerTextToClipboard($event)), ["prevent"]))
                      }, _toDisplayString(_ctx.product.product_info.cnk_code), 1)
                    ])
                  ])
                ]),
                _createVNode(_component_BaseCard, { class: "general text-bg-light border-light mb-3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", _hoisted_22, _toDisplayString(_ctx.$t('general')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('usage')), 1),
                          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.product.product_info?.usage?.description), 1)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('commerciallyAvailable')), 1),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("i", _hoisted_29, _toDisplayString(!_ctx.product.product_info?.is_commercially_available ? 'check' : 'close'), 1)
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_BaseCard, { class: "producer text-bg-light border-light mb-3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", _hoisted_31, _toDisplayString(_ctx.$t('supplier')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('brand')), 1),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.product.product_info?.brand?.description), 1)
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_BaseCard, { class: "category text-bg-light border-light mb-3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", _hoisted_36, _toDisplayString(_ctx.$t('categorization')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                      default: _withCtx(() => [
                        (_ctx.product.categories)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.categories, (category) => {
                                return (_openBlock(), _createBlock(_component_PimProductsDetailCategories, {
                                  key: category.code,
                                  "category-code": category.code,
                                  "category-path": category.path_by_name,
                                  pageUI: _ctx.productUI,
                                  readonly: ""
                                }, null, 8, ["category-code", "category-path", "pageUI"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("h3", _hoisted_39, _toDisplayString(_ctx.$t('licensedContent')), 1),
              _createElementVNode("button", {
                class: "btn btn-sm btn-icon btn-primary ms-1",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.isShowGeneralFeedback = !_ctx.isShowGeneralFeedback), ["prevent"]))
              }, _hoisted_41)
            ]),
            (_ctx.isShowGeneralFeedback)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createVNode(_component_PimFeedbackPanelOld, {
                    "is-general-remark": true,
                    onSubmitPimFeedback: _ctx.submitPimFeedback,
                    onSubmitPimFeedbackCancel: _ctx.submitPimFeedbackCancel
                  }, null, 8, ["onSubmitPimFeedback", "onSubmitPimFeedbackCancel"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_BaseCard, { class: "category text-bg-light border-light mb-3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", _hoisted_45, _toDisplayString(_ctx.$t('structuredProperties')), 1),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-icon btn-primary ms-1",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleEditCorePimDetails && _ctx.toggleEditCorePimDetails(...args)))
                        }, _hoisted_47)
                      ]),
                      _: 1
                    }),
                    (! _ctx.isCorePimDetailsEditMode)
                      ? (_openBlock(), _createBlock(_component_BaseCardBody, {
                          key: 0,
                          class: "p-2"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('commercialName')), 1),
                              _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.productInfo?.details?.commercial_name), 1)
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('trademark')), 1),
                              _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.productInfo?.details?.trademark?.description), 1)
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t('targetGroup')), 1),
                              _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.productInfo?.details?.target_group?.description), 1)
                            ]),
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.$t('unit')), 1),
                              _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.productInfo?.details?.unit?.description), 1)
                            ]),
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.$t('shape')), 1),
                              _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.productInfo?.details?.shape), 1)
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isCorePimDetailsEditMode)
                      ? (_openBlock(), _createBlock(_component_BaseCardBody, {
                          key: 1,
                          class: "p-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_dp_form, {
                              as: "form",
                              onSubmit: _ctx.submitPimCoreData,
                              novalidate: ""
                            }, {
                              default: _withCtx(({ errors }) => [
                                _createElementVNode("div", _hoisted_63, [
                                  _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.$t('commercialName')), 1),
                                  _createElementVNode("div", _hoisted_65, [
                                    _createVNode(_component_input_text, {
                                      modelValue: _ctx.corePimDetailsDto.commercial_name,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.corePimDetailsDto.commercial_name) = $event)),
                                      name: 'pim_details.commercial_name',
                                      mode: "default",
                                      errors: errors
                                    }, null, 8, ["modelValue", "name", "errors"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_66, [
                                  _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.$t('trademark')), 1),
                                  _createElementVNode("div", _hoisted_68, [
                                    _createVNode(_component_input_select, {
                                      modelValue: _ctx.corePimDetailsDto.trademark_code,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.corePimDetailsDto.trademark_code) = $event)),
                                      name: 'pim_details.trademark_code',
                                      selectText: _ctx.$t('selectText'),
                                      options: _ctx.trademarkOptions,
                                      errors: errors,
                                      "can-clear": "",
                                      class: "mb-3"
                                    }, null, 8, ["modelValue", "name", "selectText", "options", "errors"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_69, [
                                  _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.$t('targetGroup')), 1),
                                  _createElementVNode("div", _hoisted_71, [
                                    _createVNode(_component_input_select, {
                                      modelValue: _ctx.corePimDetailsDto.target_group_code,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.corePimDetailsDto.target_group_code) = $event)),
                                      name: 'pim_details.target_group_code',
                                      selectText: _ctx.$t('selectText'),
                                      options: _ctx.targetGroupOptions,
                                      errors: errors,
                                      "can-clear": "",
                                      class: "mb-3"
                                    }, null, 8, ["modelValue", "name", "selectText", "options", "errors"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_72, [
                                  _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.$t('unit')), 1),
                                  _createElementVNode("div", _hoisted_74, [
                                    _createVNode(_component_input_select, {
                                      modelValue: _ctx.corePimDetailsDto.unit_code,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.corePimDetailsDto.unit_code) = $event)),
                                      name: 'pim_details.unit_code',
                                      selectText: _ctx.$t('selectText'),
                                      options: _ctx.unitOptions,
                                      errors: errors,
                                      "can-clear": "",
                                      class: "mb-3"
                                    }, null, 8, ["modelValue", "name", "selectText", "options", "errors"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_75, [
                                  _createElementVNode("div", _hoisted_76, [
                                    _createElementVNode("div", _hoisted_77, [
                                      _createElementVNode("div", _hoisted_78, _toDisplayString(_ctx.$t('shape')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_79, [
                                      _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.$t('shapeExamples')), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_81, [
                                    _createVNode(_component_input_text, {
                                      modelValue: _ctx.corePimDetailsDto.shape,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.corePimDetailsDto.shape) = $event)),
                                      name: 'pim_details.shape',
                                      mode: "default",
                                      errors: errors
                                    }, null, 8, ["modelValue", "name", "errors"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_82, [
                                  _createElementVNode("div", _hoisted_83, [
                                    _createElementVNode("button", _hoisted_84, _toDisplayString(_ctx.$t('save')), 1)
                                  ])
                                ])
                              ]),
                              _: 1
                            }, 8, ["onSubmit"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _hoisted_85
            ]),
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("div", _hoisted_87, [
                _createVNode(_component_BaseCard, { class: "category text-bg-light border-light mb-3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", _hoisted_88, _toDisplayString(_ctx.$t('structuredTextFragments')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_BaseCardBody, { class: "p-2" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productInfo.named_text_fragments, (fragment) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: fragment,
                                class: "mb-3"
                              }, [
                                _createElementVNode("div", _hoisted_89, [
                                  _createElementVNode("div", _hoisted_90, _toDisplayString(fragment?.text_fragment?.fragment?.title), 1),
                                  _createElementVNode("div", _hoisted_91, [
                                    _createElementVNode("button", {
                                      class: "btn btn-sm btn-icon btn-primary ms-1",
                                      onClick: _withModifiers(($event: any) => (_ctx.toggleIsShowFeedbackForFragmentWithId(fragment?.id)), ["prevent"])
                                    }, _hoisted_94, 8, _hoisted_92),
                                    _createElementVNode("button", {
                                      class: "btn btn-sm btn-icon btn-primary ms-1",
                                      onClick: _withModifiers(($event: any) => (_ctx.toggleIsEditingNamedTextFragmentWithId(fragment?.id)), ["prevent"])
                                    }, _hoisted_97, 8, _hoisted_95),
                                    _createElementVNode("button", {
                                      class: "btn btn-sm btn-icon btn-danger ms-1",
                                      onClick: _withModifiers(($event: any) => (_ctx.confirmDeleteFragment(fragment?.id)), ["prevent"])
                                    }, _hoisted_100, 8, _hoisted_98)
                                  ])
                                ]),
                                (_ctx.isEditingNamedTextFragmentWithId === fragment?.id)
                                  ? (_openBlock(), _createBlock(_component_NamedTextFragmentPanelOld, {
                                      key: 0,
                                      "named-text-fragment": fragment,
                                      onSubmitNamedFragmentContent: _ctx.submitNamedFragmentContent,
                                      onSubmitNamedFragmentCancel: _ctx.submitNamedFragmentCancel
                                    }, null, 8, ["named-text-fragment", "onSubmitNamedFragmentContent", "onSubmitNamedFragmentCancel"]))
                                  : _createCommentVNode("", true),
                                (_ctx.isShowFeedbackForFragmentWithId === fragment?.id)
                                  ? (_openBlock(), _createBlock(_component_PimFeedbackPanelOld, {
                                      key: 1,
                                      "is-general-remark": false,
                                      "field-code": fragment.text_fragment.code,
                                      "text-fragment-id": fragment.id,
                                      onSubmitPimFeedback: _ctx.submitPimFeedback,
                                      onSubmitPimFeedbackCancel: _ctx.submitPimFeedbackCancel
                                    }, null, 8, ["field-code", "text-fragment-id", "onSubmitPimFeedback", "onSubmitPimFeedbackCancel"]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                  innerHTML: fragment?.text_fragment?.fragment?.content,
                                  class: "value"
                                }, null, 8, _hoisted_101)
                              ]))
                            }), 128)),
                            _createElementVNode("div", null, [
                              (! _ctx.isNewNamedTextFragmentPanelOpen)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openNewNamedTextFragmentPanel && _ctx.openNewNamedTextFragmentPanel(...args)), ["prevent"])),
                                    class: "btn btn-sm btn-icon btn-primary d-flex align-items-center"
                                  }, [
                                    _hoisted_102,
                                    _createTextVNode(_toDisplayString(_ctx.$t('new')), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.isNewNamedTextFragmentPanelOpen)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                    (_ctx.isNewNamedTextFragmentPanelOpen)
                                      ? (_openBlock(), _createBlock(_component_NamedTextFragmentPanelOld, {
                                          key: 0,
                                          onSubmitNamedFragmentContent: _ctx.submitNamedFragmentContent,
                                          onSubmitNamedFragmentCancel: _ctx.submitNamedFragmentCancel
                                        }, null, 8, ["onSubmitNamedFragmentContent", "onSubmitNamedFragmentCancel"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}